import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Utensils, Waves, ShieldPlus, ArrowUpRight } from "lucide-react";

const workshops = [
  {
    id: "lunch-and-learn",
    icon: Utensils,
    tag: "Lunch & Learn",
    title: "Lunch & Learn workshops",
    excerpt:
      "Bite-sized workshops delivered over lunch on Mindfulness, Resilience and Supportive Communication — perfect for teams wanting a light-touch, high-impact intervention.",
  },
  {
    id: "mindfulness",
    icon: Waves,
    tag: "Wellbeing",
    title: "Mindfulness workshops",
    excerpt:
      "Practical mindfulness sessions for the workplace. Simple, evidence-based techniques your team can use between meetings to reset attention and reduce stress.",
  },
  {
    id: "resilient-behaviour",
    icon: ShieldPlus,
    tag: "Resilience",
    title: "Resilient Behaviour workshops",
    excerpt:
      "Build the habits, mindset and language of resilient teams. A structured workshop on responding to pressure, change and setbacks in healthy, sustainable ways.",
  },
];

export default function AdditionalWorkshops() {
  return (
    <section data-testid="additional-workshops-section" className="section relative">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 items-end">
          <div className="md:col-span-7">
            <p className="eyebrow mb-4">Bespoke Workshops</p>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.02] tracking-tight text-[#1E2A25]">
              Beyond MHFA — <br />
              <span className="italic text-[#4A5D52]">tailored workshops</span> for your team.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 text-[#4A5D52] leading-relaxed">
            These sessions are arranged directly with Liz to suit your team, timings and objectives —
            no fixed dates. Get in touch to design a workshop around your organisation.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {workshops.map((w, i) => {
            const Icon = w.icon;
            return (
              <motion.article
                key={w.id}
                data-testid={`workshop-${w.id}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="group bg-[#F3EFEA] rounded-3xl p-8 md:p-10 hover:-translate-y-1 transition-transform duration-500"
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="w-11 h-11 rounded-full bg-[#FDFBF7] text-[#4A5D52] flex items-center justify-center">
                    <Icon className="w-5 h-5" strokeWidth={1.5} />
                  </span>
                  <span className="eyebrow text-[#D88C76]">{w.tag}</span>
                </div>
                <h3 className="font-serif-display text-2xl md:text-3xl text-[#1E2A25] leading-tight">{w.title}</h3>
                <p className="mt-4 text-[#4A5D52] leading-relaxed">{w.excerpt}</p>
                <div className="mt-8">
                  <Link
                    to={`/contact?course=${encodeURIComponent(w.title)}`}
                    data-testid={`workshop-cta-${w.id}`}
                    className="link-underline"
                  >
                    Enquire with us <ArrowUpRight className="w-4 h-4" />
                  </Link>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
